import styled from "styled-components";
import { Modal } from "antd";
import { ModalProps } from "antd/lib/modal";
import shadows from "theme/shadows.module.scss";
import spacing from "theme/spacing.module.scss";
import colors from "theme/colors.module.scss";
import borders from "theme/borders.module.scss";

export const StyledModal = styled(Modal)<ModalProps>`
    .ant-modal-content {
        display: flex;
        flex-direction: column;
        padding: ${spacing.spacing} ${spacing.spacing} ${spacing.spacingLG};
        border-radius: ${borders.borderRadiusSM};
        min-height: 180px;
        box-shadow: ${shadows.primaryShadow};
    }

    .ant-btn {
        margin-inline-start: 0 !important;
    }

    .ant-modal-close {
        width: 24px;
        height: 24px;

        svg {
            color: ${colors.text500};
        }
    }
`
